module.exports = __webpack_public_path__ + "static/img/index_main.jpg";